import React from 'react'
import "./footer.css"

const Footer = () => {
  return (
    <>
      <div className="h-20 mt-10 relative bg-gray-950">
        <div class="custom-shape-divider-top-1709843139">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" class="shape-fill"></path>
            </svg>
           </div> 
      </div>
        
    </>
    
  )
}

export default Footer
